import type { AvailabilityGroupClientDto } from 'service-api/src/types/api'

type TAvailability = NonNullable<AvailabilityGroupClientDto['availabilities']>[number]

export const waitlistEligible = (availability?: TAvailability[]) => {
  if (!availability) return false
  const firstAvailability = availability?.[0]
  if (!firstAvailability) return false
  const { unavailableType, unavailableReason } = firstAvailability
  if (unavailableType === 'INVENTORY') return true
  // MBV restriction is allowed to waitlist
  if (unavailableType === 'RESTRICTION' && unavailableReason?.type === 'PRICE') return true
  return false
}
